import TwoDimensionalVideo from './components/TwoDimensionalVideo/TwoDimensionalVideo.jsx';

export {
	TwoDimensionalVideo,
};
